<template>
  <div class="message-item" :class="{ 'user-message': isUser }">
    <div class="message-bubble">
      <!-- 文本内容 -->
      <p v-if="content">{{ content }}</p>
      <!-- 文件信息（如果有） -->
      <div v-if="file" class="file-info">
        <i class="file-icon">📎</i>
        <span>{{ file.name }}</span>
        <span class="file-size">{{ formatSize(file.size) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    isUser: Boolean, // 是否是用户发送的消息
    file: Object // 文件对象（可选）
  },
  methods: {
    formatSize(bytes) {
      if (bytes < 1024) return `${bytes}B`
      return `${(bytes / 1024).toFixed(1)}KB`
    }
  }
}
</script>

<style scoped>
.message-item {
  margin-bottom: 12px;
  display: flex;
}

/* 用户消息靠右，AI消息靠左 */
.user-message {
  justify-content: flex-end;
}

.message-bubble {
  max-width: 70%;
  padding: 10px 15px;
  border-radius: 18px;
  word-break: break-all;
}

/* 区分用户和AI的消息样式 */
.message-item:not(.user-message) .message-bubble {
  background-color: #f0f0f0;
}

.user-message .message-bubble {
  background-color: #42b983;
  color: white;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-size {
  font-size: 12px;
  opacity: 0.8;
}
</style>